import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '../config/firebase';

const C = {
  bg: '#0A0F0D',
  panel: '#121A17',
  ink: '#F4F7F5',
  inkSoft: '#9CA8A2',
  green: '#2EE06B',
  greenDim: '#1F9E4D',
  greenSoft: 'rgba(46,224,107,0.12)',
  border: 'rgba(255,255,255,0.08)'
};

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}

const Logo = ({ size = 56 }) => (
  <img src="/logo.png" alt="Winal" style={{ width: size, height: size, display: 'block' }} />
);

const Glow = (style) => <div style={{ position: 'absolute', borderRadius: '50%', filter: 'blur(80px)', zIndex: 0, ...style }} />;

const PADEL_HOLES = [
  [40, 24], [50, 22], [60, 24], [34, 32], [44, 32], [56, 32], [66, 32],
  [38, 42], [50, 42], [62, 42], [34, 52], [44, 52], [56, 52], [66, 52], [50, 60]
];
function PadelIcon({ size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
      <rect x="42" y="66" width="16" height="22" rx="7" fill="#2B2118" />
      <ellipse cx="50" cy="40" rx="34" ry="38" fill="#1C1C1C" stroke="#D4843C" strokeWidth="3" />
      {PADEL_HOLES.map(([x, y], i) => <circle key={i} cx={x} cy={y} r="2.4" fill="#3D3D3D" />)}
      <circle cx="80" cy="74" r="9" fill="#D8E84A" />
      <circle cx="90" cy="86" r="9" fill="#D8E84A" />
    </svg>
  );
}

const RESULTS = [
  { emoji: '🏓', name: 'Palermo Pádel Club', meta: '19:00 · 2/4 jugadores · $18.000' },
  { emoji: '🏓', name: 'La Rural Pádel', meta: '20:00 · 3/4 jugadores · $20.000' },
  { emoji: '🏓', name: 'Pádel & Friends', meta: '21:00 · 1/4 jugadores · $16.000' },
];

function PhoneMock() {
  return (
    <div style={{ width: 320, background: '#000', borderRadius: 32, padding: 10, boxShadow: '0 30px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.05)', flexShrink: 0 }}>
      <div style={{ background: '#0B141A', borderRadius: 24, overflow: 'hidden' }}>
        <div style={{ background: '#1F2C26', padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
          <Logo size={24} />
          <div>
            <b style={{ color: 'white', fontSize: 13, display: 'block' }}>Winal</b>
            <span style={{ color: '#8FA89C', fontSize: 10.5 }}>en línea</span>
          </div>
        </div>
        <div style={{ padding: 14, minHeight: 360 }}>
          <div style={{ background: '#005C4B', color: 'white', borderRadius: '10px 10px 2px 10px', padding: '9px 12px', fontSize: 12.5, marginBottom: 10, marginLeft: 'auto', maxWidth: '80%' }}>
            Quiero jugar pádel hoy después de las 19
          </div>
          <div style={{ background: '#1F2C26', color: '#E8EFE9', borderRadius: '10px 10px 10px 2px', padding: '10px 12px', fontSize: 12, marginBottom: 10, maxWidth: '88%' }}>
            Encontré 3 opciones para hoy:
          </div>
          {RESULTS.map((r, i) => (
            <div key={i} style={{ background: '#1A2420', borderRadius: 10, padding: 10, marginBottom: 8, display: 'flex', gap: 10, alignItems: 'center' }}>
              <div style={{ width: 42, height: 42, borderRadius: 8, background: 'linear-gradient(135deg, rgba(46,224,107,0.2), rgba(31,158,77,0.35))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 }}>{r.emoji === '🏓' ? <PadelIcon size={24} /> : r.emoji}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <b style={{ color: 'white', fontSize: 11.5, display: 'block' }}>{r.name}</b>
                <span style={{ color: '#8FA89C', fontSize: 10 }}>{r.meta}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function LoginPanel({ onGoogleLogin, loading, error }) {
  const [demoName, setDemoName] = useState('');
  const [demoEmail, setDemoEmail] = useState('');
  const [demoPhone, setDemoPhone] = useState('');
  const [demoComment, setDemoComment] = useState('');
  const [demoSent, setDemoSent] = useState(false);
  const [demoLoading, setDemoLoading] = useState(false);

  const handleDemoRequest = async () => {
    if (!demoEmail.trim()) return;
    setDemoLoading(true);
    try {
      await fetch('https://api.winal.app/api/demo-request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: demoName, email: demoEmail, phone: demoPhone, comment: demoComment })
      });
    } catch (e) { /* silencioso */ }
    finally {
      setDemoSent(true);
      setDemoLoading(false);
    }
  };

  const fieldStyle = {
    width: '100%', background: '#0E1512', border: `1.5px solid ${C.border}`, borderRadius: 12,
    padding: '11px 14px', color: C.ink, fontSize: 14, fontFamily: "'Nunito', sans-serif",
    outline: 'none', marginBottom: 10, boxSizing: 'border-box'
  };

  return (
    <div style={{ width: '100%', maxWidth: 360, position: 'relative', zIndex: 2 }}>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 19, fontWeight: 800, color: C.ink, marginBottom: 6 }}>Sumate gratis hoy</div>
        <div style={{ fontSize: 13.5, color: C.inkSoft }}>Sin tarjeta · tu primer plan en minutos</div>
      </div>

      <button onClick={onGoogleLogin} disabled={loading} style={{
        width: '100%', background: loading ? '#1A2420' : '#FFFFFF', color: '#16222E',
        border: 'none', borderRadius: 999, padding: '14px 16px',
        fontSize: 15, fontWeight: 800,
        cursor: loading ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center',
        justifyContent: 'center', gap: 12, opacity: loading ? 0.7 : 1
      }}>
        <svg width="18" height="18" viewBox="0 0 48 48">
          <path fill="#FFC107" d="M43.6 20H24v8h11.3C33.6 33.1 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.1 6.5 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11 0 20-8.9 20-20 0-1.3-.1-2.7-.4-4z"/>
          <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34.1 6.5 29.3 4 24 4 16.3 4 9.7 8.4 6.3 14.7z"/>
          <path fill="#4CAF50" d="M24 44c5.2 0 9.9-1.9 13.5-5L31 33.5C29 35 26.6 36 24 36c-5.3 0-9.6-2.9-11.3-7.1l-6.6 5.1C9.6 39.6 16.3 44 24 44z"/>
          <path fill="#1976D2" d="M43.6 20H24v8h11.3c-.8 2.3-2.3 4.2-4.3 5.5L37.5 39c3.4-3.2 5.5-7.8 5.5-13 0-1.3-.1-2.7-.4-4z"/>
        </svg>
        {loading ? 'Iniciando...' : 'Continuar con Google'}
      </button>

      {error && (
        <div style={{ color: '#FF8A8A', fontSize: 12, marginTop: 10, padding: '8px 12px', background: 'rgba(239,68,68,0.14)', borderRadius: 8 }}>
          {error}
        </div>
      )}

      <div style={{ margin: '22px 0', display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ flex: 1, height: 1.5, background: C.border }} />
        <div style={{ fontSize: 11, color: C.inkSoft, fontWeight: 700 }}>incluye</div>
        <div style={{ flex: 1, height: 1.5, background: C.border }} />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 26 }}>
        {[
          { emoji: '💬', text: 'Buscá y sumate a planes por WhatsApp' },
          { emoji: '🗓️', text: 'Panel web para ver y armar tus eventos' },
          { emoji: '🏟️', text: '¿Tenés un club? Publicá tu cancha' },
        ].map((item, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: C.inkSoft }}>
            <span>{item.emoji}</span><span>{item.text}</span>
          </div>
        ))}
      </div>

      <div style={{ height: 1.5, background: C.border, marginBottom: 22 }} />

      {!demoSent ? (
        <div>
          <div style={{ fontSize: 14, fontWeight: 800, color: C.ink, marginBottom: 4 }}>¿Tenés un club o cancha?</div>
          <div style={{ fontSize: 12.5, color: C.inkSoft, marginBottom: 12 }}>Dejá tu contacto y te ayudamos a sumar gente.</div>
          <input style={fieldStyle} value={demoName} onChange={e => setDemoName(e.target.value)} placeholder="Tu nombre" />
          <input style={fieldStyle} value={demoEmail} onChange={e => setDemoEmail(e.target.value)} placeholder="tu@email.com" type="email" />
          <input style={fieldStyle} value={demoPhone} onChange={e => setDemoPhone(e.target.value)} placeholder="Tu WhatsApp o teléfono" type="tel" />
          <textarea style={{ ...fieldStyle, resize: 'none' }} rows={3} value={demoComment} onChange={e => setDemoComment(e.target.value)} placeholder="¿Qué cancha/club tenés?" />
          <button onClick={handleDemoRequest} disabled={demoLoading || !demoEmail.trim()} style={{
            width: '100%', background: 'transparent', border: `1.5px solid ${C.border}`, borderRadius: 10,
            padding: 11, fontSize: 13, fontWeight: 800, color: C.inkSoft, cursor: 'pointer',
            opacity: !demoEmail.trim() ? 0.5 : 1
          }}>
            {demoLoading ? 'Enviando...' : 'Quiero sumar mi cancha →'}
          </button>
        </div>
      ) : (
        <div style={{ padding: 16, background: C.greenSoft, borderRadius: 12, textAlign: 'center' }}>
          <div style={{ fontSize: 22, marginBottom: 6 }}>✅</div>
          <div style={{ fontSize: 14, fontWeight: 800, color: C.green, marginBottom: 4 }}>¡Listo!</div>
          <div style={{ fontSize: 12.5, color: C.inkSoft }}>Te contactamos en las próximas horas.</div>
        </div>
      )}

      <div style={{ marginTop: 26, paddingTop: 16, borderTop: `1.5px solid ${C.border}`, textAlign: 'center' }}>
        <div style={{ fontSize: 11, color: C.inkSoft, lineHeight: 1.8 }}>
          Winal · <strong style={{ color: C.ink }}>Cristian Hernandez</strong>
          <br />CUIT 20-31014325-2 · Buenos Aires, Argentina
          <br />
          <a href="/terms" style={{ color: C.inkSoft, textDecoration: 'none' }}>Términos</a>
          {' · '}
          <a href="/privacy" style={{ color: C.inkSoft, textDecoration: 'none' }}>Privacidad</a>
          {' · '}
          <span>soporte@winal.app</span>
        </div>
      </div>
    </div>
  );
}

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      navigate('/dashboard');
    } catch (e) {
      setError('Error al iniciar sesión. Intentá de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  if (isMobile) {
    return (
      <div style={{ minHeight: '100vh', background: `radial-gradient(circle at 20% 0%, #102018 0%, ${C.bg} 60%)`, fontFamily: "'Nunito', sans-serif", display: 'flex', flexDirection: 'column', padding: '36px 24px', position: 'relative', overflow: 'hidden' }}>
        {Glow({ width: 280, height: 280, background: C.green, opacity: 0.08, top: -80, right: -70 })}
        {Glow({ width: 220, height: 220, background: C.green, opacity: 0.05, bottom: 40, left: -60 })}
        <div style={{ marginBottom: 28, position: 'relative', zIndex: 2 }}><Logo size={64} /></div>
        <div style={{ marginBottom: 32, position: 'relative', zIndex: 2 }}>
          <div style={{ display: 'inline-block', background: C.greenSoft, color: C.green, fontSize: 11, fontWeight: 800, padding: '5px 12px', borderRadius: 999, marginBottom: 16, letterSpacing: 0.4 }}>TODO POR WHATSAPP</div>
          <div style={{ fontSize: 32, fontWeight: 800, color: C.ink, lineHeight: 1.15, marginBottom: 12, letterSpacing: -0.5 }}>
            Encontrá dónde <span style={{ color: C.green }}>jugar.</span> Sin descargar nada.
          </div>
          <div style={{ fontSize: 14.5, color: C.inkSoft, lineHeight: 1.6 }}>Escribís lo que querés hacer, la IA busca disponibilidad y te conecta con tu próximo partido.</div>
        </div>
        <LoginPanel onGoogleLogin={handleGoogleLogin} loading={loading} error={error} />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', height: '100vh', background: `radial-gradient(circle at 15% 0%, #102018 0%, ${C.bg} 55%)`, fontFamily: "'Nunito', sans-serif", overflow: 'hidden' }}>

      <div style={{ flex: 1, overflowY: 'auto', padding: '44px 56px', position: 'relative' }}>
        {Glow({ width: 420, height: 420, background: C.green, opacity: 0.08, top: -120, right: '10%' })}
        {Glow({ width: 320, height: 320, background: C.green, opacity: 0.05, bottom: 0, left: '5%' })}

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 56, position: 'relative', zIndex: 2 }}>
          <Logo size={36} />
          <span style={{ color: C.ink, fontWeight: 800, fontSize: 17 }}>Win<span style={{ color: C.green }}>al</span></span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 50, position: 'relative', zIndex: 2, marginBottom: 70 }}>
          <div style={{ flex: 1, maxWidth: 480 }}>
            <div style={{ display: 'inline-block', background: C.greenSoft, color: C.green, fontSize: 11.5, fontWeight: 800, padding: '6px 14px', borderRadius: 999, marginBottom: 22, letterSpacing: 0.5 }}>TODO POR WHATSAPP</div>
            <div style={{ fontSize: 46, fontWeight: 800, color: C.ink, lineHeight: 1.12, marginBottom: 18, letterSpacing: -1 }}>
              Encontrá dónde<br /><span style={{ color: C.green }}>jugar.</span> Sin<br />descargar nada.
            </div>
            <div style={{ color: C.inkSoft, fontSize: 15.5, lineHeight: 1.7, marginBottom: 30 }}>
              Escribís lo que querés hacer, la IA busca disponibilidad en los clubes que ya están en Winal y te conecta con tu próximo partido.
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ display: 'flex' }}>
                {[0, 1, 2, 3].map(i => (
                  <div key={i} style={{ width: 30, height: 30, borderRadius: '50%', border: `2px solid ${C.bg}`, background: 'linear-gradient(135deg, #2EE06B, #1F9E4D)', marginLeft: i ? -8 : 0 }} />
                ))}
              </div>
              <span style={{ color: C.inkSoft, fontSize: 12.5 }}>+10.000 personas ya encontraron su próximo partido</span>
            </div>
          </div>
          <PhoneMock />
        </div>

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center', position: 'relative', zIndex: 2 }}>
          {['🏓 Pádel', '⚽ Fútbol', '🎾 Tenis', '🏀 Básquet', '🏃 Running', '➕ Y más'].map(t => {
            const [emoji, ...rest] = t.split(' ');
            return (
              <div key={t} style={{ background: C.panel, border: `1px solid ${C.border}`, borderRadius: 14, padding: '14px 18px', textAlign: 'center', minWidth: 80 }}>
                <div style={{ fontSize: 20, marginBottom: 6, display: 'flex', justifyContent: 'center' }}>{emoji === '🏓' ? <PadelIcon size={22} /> : emoji}</div>
                <span style={{ color: C.inkSoft, fontSize: 11.5, fontWeight: 700 }}>{rest.join(' ')}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div style={{
        width: 440, flexShrink: 0, height: '100vh', position: 'sticky', top: 0,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start',
        padding: '32px 44px', background: C.panel, borderLeft: `1px solid ${C.border}`, overflowY: 'auto'
      }}>
        <LoginPanel onGoogleLogin={handleGoogleLogin} loading={loading} error={error} />
      </div>

    </div>
  );
}